import { render, staticRenderFns } from "./VarianceReport.vue?vue&type=template&id=25139642"
import script from "./VarianceReport.vue?vue&type=script&lang=js"
export * from "./VarianceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports